import React, { Component } from "react";
import { getMessage } from "CONFIG/i18n";
import { func } from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { isIE, isFirefox } from "react-device-detect";

import Spinner from "COMPONENTS/Spinner/Spinner";

import { getURLParameter, setCaretToEnd, checkEmpty, removeTrailingSlash, getAnnouncementUser, isAnnouncementBlank } from "UTILS/Utility";
import { CONFIG, ERROR, PASSCODE_LENGTH, NAME_NG_REGEX } from "UTILS/Constants";

import { Row, Col, Container, InputGroup, Input, Button } from "reactstrap";
import session_img from "../../Assets/Images/menu_icons/icon_guest.svg";
import HeaderContainer from "COMPONENTS/Header/HeaderContainer";
import ChangeLanguage from "COMPONENTS/CommonComponents/ChangeLanguage/ChangeLanguage";

import { logoutAction, systemAnnouncementAction } from "CONFIG/ActionFactory";
import setLanguageAction from "COMPONENTS/CommonComponents/ChangeLanguage/setLanguageAction";

//ASSETS
import icBar from "ASSETS/Images/ic_bar.svg"

import "./UserJoin.less"
class UserJoin extends Component {
  static propTypes = {
    handleProceed: func
  };
  constructor(props) {
    super(props);
    this.state = {
      userName: "",
      passcode: [],
      code0: "",
      code1: "",
      code2: "",
      code3: "",
      errorMessage: "",
      uriIdentifier: removeTrailingSlash(window.location.pathname).split("/")[1]
    };
  }

  componentDidMount() {
    // get active announcements
    systemAnnouncementAction.getAllActiveAnnouncementsAction().then(
      (response) => {
        this.setState({
          activeAnnouncements: response.data
        })
      },
      error => {
        console.error(error);
      }
    )
    
    logoutAction.logoutreducerAction()
    // set if present in url
    let userName = getURLParameter("name");
    if (!checkEmpty(userName)){
      userName = userName.substr(0, 50);
      this.setState({userName: userName});
    }
    // focus the user name field if session key is present - join meeting using session link
    if(this.props.sessionKey) {
      document.getElementById('userName').focus();
    }

    window.addEventListener('online', this.handleErrorMessagOnNetworkState);
  }

  componentDidUpdate (prevProps){
    if(this.props.sessionKey !== prevProps.sessionKey){
      this.setState({errorMessage: ""})
      // focus the user name field if session key is present - join meeting using session link
      if(this.props.sessionKey) {
        document.getElementById('userName').focus();
      }
    }
  }

  componentWillUnmount(){
    console.log("UserJoin componentWillUnmount")
    window.removeEventListener('online', this.handleErrorMessagOnNetworkState);
  }

  handleInputChange = event => {
    this.setState({
      userName: event.target.value,
      errorMessage: ""
    }) 
  }

  handlePasscodeChange = event => { 
    if(event.target.value !== " ") {
      let inputNumber = parseInt(event.target.name)
      if(isNaN(event.target.value) ){
        this.setState({
          errorMessage: "NOT_A_NUMBER_ERROR"
        }) } else {
        let passcode = this.state.passcode;
        passcode[inputNumber] = event.target.value;
        this.setState({
          [event.target.id]: event.target.value.trim(),
          passcode,
          errorMessage: ""
        })

        if (event.target.value && inputNumber == 3) {
          document.getElementById("userName").focus()
        } else {
          event.target.value && 
          (!document.getElementById("code"+(inputNumber+1))?.value || 
          document.getElementById("code"+(inputNumber-1))?.value)  ?
              document.getElementById("code"+(inputNumber+1))?.focus() :
              document.getElementById("code"+(inputNumber-1))?.focus()
        }
      }
    } else {
      this.setState({errorMessage: getMessage("SPACE_IS_NOT_ALLOWED")})
    }
  }

  onFocusHandle= (event) =>{
    setCaretToEnd(document.getElementById(event.target.id));
  }

  handleProceed = () => {
    if(this.props.sessionKey){
      const user = this.state.userName.trim();
      if (!checkEmpty(user) && user.match(NAME_NG_REGEX)) {
        this.setState({ errorMessage: "NAME_ERROR_MSG" });
        return;
      }
      this.props.handleProceed(
        this.state.userName.trim(),
        this.errorcallBack
      );
    } else if(this.isValidJoinSessionData()) {

      let sessionDetails = {
        passcode: this.state.passcode.join(""),
        uriIdentifier: this.state.uriIdentifier
      };

      this.props.handleJoinWithPasscode(
        sessionDetails,
        this.state.userName.trim(),
        this.errorcallBack
      ) 
    }
  };

  handleErrorMessagOnNetworkState = () => {
    let errorMessage = this.state.errorMessage == ERROR.NETWORK_ERROR ? "" : this.state.errorMessage
    this.setState({
      errorMessage: errorMessage
    });
  }

  isValidJoinSessionData(){
    //check if organization name is present or not
    if(this.state.uriIdentifier.toLowerCase() === 'joinwithpasscode') {
      this.setState({errorMessage: "INVALID_LINK"});
      return false;
    }
    //check the passcode is not empty
    if(!this.state.passcode.join("").trim().length) {
      this.setState({errorMessage: "PASSCODE_CANNOT_BE_EMPTY"});
      return false;
    }
    //check the length of passcode is valid 
    if(this.state.passcode.length < PASSCODE_LENGTH) {
      this.setState({errorMessage: "PASSCODE_DIGIT_LENGTH_VALIDATION"});
      return false;
    }
    const user = this.state.userName.trim();
    if (!checkEmpty(user) && user.match(NAME_NG_REGEX)) {
      this.setState({ errorMessage: "NAME_ERROR_MSG" });
      return false;
    }
    return true;
  }
  
  enterPressed = event => {
    var code = event.keyCode || event.which;
    if (code === 13) {
      this.handleProceed();
    }
  };

  errorcallBack = errorMessage =>{
    //If API fails this function get called with error code
    this.setState({ errorMessage: errorMessage});
  }

  onSelectChange = selectedLanguage => {
    this.props.setLanguageAction(selectedLanguage);
  };
  renderSprinner =()=> {
    return <Spinner showSpinner={this.props.spinnerVisibility} />;
  }

  keyPressHandle =event=> {
    let inputFieldNumber= parseInt(event.target.name);
    var code = event.keyCode || event.which;
    if(code == 37){
      event.preventDefault();
      document.getElementById("code"+(inputFieldNumber-1))?.focus();
    } else if(code == 39) {
      document.getElementById("code"+(inputFieldNumber+1))?.focus();
    } else if (code === 13) {
      this.handleProceed();
    }
  }

  passcodeInput =()=> {
    return(
      <div className="d-flex justify-content-center ml-md-5">
        <div className="col-3 col-sm-2 col-md-1 col-lg-1 px-1 px-sm-2 px-md-0 mx-sm-2">
          <input 
            id="code0"
            type="tel"
            className="w-100 text-center py-0 passcodeDigit form-control"
            name="0" 
            value={this.state.code0}
            onChange={this.handlePasscodeChange}
            onKeyDown={this.keyPressHandle}
            maxLength={1}
            onFocus={this.onFocusHandle}
            autoFocus/>
        </div>
        <div className="col-3 col-sm-2 col-md-1 col-lg-1 px-1 px-sm-2 px-md-0 mx-sm-2">
          <input 
            id="code1"
            type="tel"
            className="w-100 text-center py-0 passcodeDigit form-control"
            name="1" 
            value={this.state.code1}
            onChange={this.handlePasscodeChange}
            onKeyDown={this.keyPressHandle}
            maxLength={1}
            onFocus={this.onFocusHandle}/>
        </div>
        <div className="col-3 col-sm-2 col-md-1 col-lg-1 px-1 px-sm-2 px-md-0 mx-sm-2">
          <input 
            id="code2"
            type="tel"
            className="w-100 text-center py-0 passcodeDigit form-control"
            name="2" 
            value={this.state.code2}
            onChange={this.handlePasscodeChange}
            onKeyDown={this.keyPressHandle}
            maxLength={1}
            onFocus={this.onFocusHandle}/>
        </div>
        <div className="col-3 col-sm-2 col-md-1 col-lg-1 px-1 px-sm-2 px-md-0 mx-sm-2">
          <input 
            id="code3"
            type="tel"
            className="w-100 text-center py-0 passcodeDigit form-control"
            name="3" 
            value={this.state.code3}
            onChange={this.handlePasscodeChange}
            onKeyDown={this.keyPressHandle}
            maxLength={1}
            onFocus={this.onFocusHandle}/>
        </div>
      </div>
    )
  }

  render() {
    return (
      <React.Fragment>
        {this.renderSprinner()}
        <HeaderContainer/>
        <div className="joinSession">
          <div className="px-2">
            <div className="languageSelection">
              <div className="mt-1">
                <ChangeLanguage
                  onSelectChange={this.onSelectChange}
                  language={this.props.language}
                />
              </div>
            </div>
            <div className="sessionImgArea col-12 col-xl-6 offset-xl-3 d-flex justify-content-center">
              <div className="col-5 col-sm-3 p-0 d-flex flex-column">
                <Row>
                  <Col xs={12} md={12} className="text-center">
                    <img
                      src={session_img}
                      className="img-responsive session-img"
                      alt={getMessage("JOIN_SESSION")}
                    />
                  </Col>
                </Row>
              </div>
            </div>
            <Row className="noMargin">
              <Col xs={12} md={12} className="text-center">
                <p className="sessionName">{getMessage("JOIN_SESSION")}</p>
              </Col>
            </Row>
            {window.location.href.toLowerCase().indexOf("join?") !== -1 ? (
              (isAnnouncementBlank(this.state.activeAnnouncements, getMessage("USER_URL_SCREEN")) ? 
                <marquee>
                  <div className="announcementUserJoinLabel">
                    <label>
                      {getAnnouncementUser(this.state.activeAnnouncements, window.location.href)}
                    </label>
                  </div> 
                </marquee> : null)) : null
            }
            {window.location.href.toLowerCase().indexOf(CONFIG.path.joinWithPasscode.toLowerCase()) !== -1 ? (
              (isAnnouncementBlank(this.state.activeAnnouncements, getMessage("USER_PASSCODE_SCREEN")) ?
                <marquee>
                  <div className="announcementUserJoinLabel">
                    <label>
                      {getAnnouncementUser(this.state.activeAnnouncements, window.location.href)}
                    </label>
                  </div> 
                </marquee>: null)) : null
            }
            <div className="card-body px-1 px-sm-4 pt-4 offset-xl-2 col-xl-8 flex flex-column pb-3 pb-xl-0">
              { !this.props.sessionKey &&
                <div className="d-flex align-items-center pb-2 title justify-content-start">
                  <img src={icBar} className="mr-2"/>
                  {getMessage("ENTER_PASSCODE_MESSAGE")}
                </div>
              }
              <div className="container">
                <div className="d-sm-flex justify-content-center">
                  <div className="col-12 col-lg-11">
                    { !this.props.sessionKey &&this.passcodeInput()}
                  </div>
                </div>
                <div className="d-sm-flex justify-content-center mt-4">
                  <InputGroup className={!this.props.sessionKey?"col-12 px-0 px-sm-2 col-sm-9 offset-sm-2 col-md-6 offset-md-2 col-lg-6 offset-lg-1 pl-md-5 col-xl-6 offset-xl-1":"px-sm-2"}>
                    <Input
                      id="userName"
                      type="text"
                      onChange={this.handleInputChange}
                      name="userName"
                      placeholder={getMessage("ENTER_YOUR_NAME") }
                      aria-label="Enter name"
                      className="formControlName form-controll rounded-pill border"
                      value={ this.state.userName }
                      maxLength={50}
                      onKeyPress={this.enterPressed}
                    />
                  </InputGroup> 
                  <div className="col-12 px-sm-0 col-sm-2 pt-4 pt-sm-0">
                    <Button
                      className={!this.props.sessionKey ? "proceedBtn customBtn whiteOnClick w-100":"proceedBtn customBtn whiteOnClick w-100"}
                      onClick={this.handleProceed}
                    >
                      {getMessage("PROCEED")}
                    </Button>
                  </div>
                </div>
              </div> 
              <div className="col-sm-11 pr-sm-4 px-0">
                <div className="errors">{getMessage(this.state.errorMessage,{maxNoOfDigit: PASSCODE_LENGTH})}</div>  
              </div>
            </div>

            <Col xs={12} md={12} className="text-center">
            </Col> 
          </div>
          {/* {!isIE && !isFirefox &&
              <div
                className="d-flex justify-content-center"
              >
                <span  
                  className="testPageLink cursorPointer text-center"
                  onClick={() => {
                    window.open('/testPage', '_blank');
                  }}>
                  {getMessage("TEST_PAGE")}
                </span>
              </div>
          }  */}
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    language: state.LanguageReducer.language
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ setLanguageAction }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserJoin);
